module.exports = __webpack_public_path__ + "img/40_75.0d2dac7a.png";